import { colors } from '@aloft/toolkit-sui';
import { StyleSheet, View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '12px',
    border: `1px solid ${colors.strokeDefault}`,
  },
});

export const ExportChartContainer = ({ title, children }: PropsWithChildren<{ title: string }>) => {
  return (
    <View style={styles.container}>
      <Text variant="h3">{title}</Text>
      {children}
    </View>
  );
};
